// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1s1Ft","title":"AfterFrontImage_title__1mKGW"};